import { render, staticRenderFns } from "./InteractionEditModal.vue?vue&type=template&id=5be24dd6&scoped=true&"
import script from "./InteractionEditModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./InteractionEditModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be24dd6",
  null
  
)

export default component.exports